import React from 'react';
import { Button } from 'antd';
import intl from 'react-intl-universal';

import CustomForm, { IFieldItem, IMyFormRef } from '@/components/CustomForm';

import styles from './index.module.scss';

// 搜索
interface FormProps {
  formRef: React.Ref<IMyFormRef>;
  onSearch: () => void;
  onReset: () => void;
  onExport: () => void;
}

const FormAttr: Array<IFieldItem> = [
  {
    label: '',
    key: 'keyWord',
    type: 'text',
    componentProps: {
      placeholder: intl.get('channel_operate_log_all_content_search'),
      allowClear: true,
    },
  },
];

const Index: React.FC<FormProps> = (props) => {
  const { formRef, onSearch, onReset, onExport } = props;

  return (
    <div className={styles.searchFormWrapper}>
      <div className={styles.formBody}>
        <CustomForm
          layout="inline"
          submitType="filter"
          showBtn
          queryText={intl.get('app_btn_query')}
          className={styles.searchForm}
          ref={formRef}
          formAttr={FormAttr}
          onFinish={onSearch}
          onReset={onReset}
        />
      </div>
      <Button type="primary" onClick={onExport}>
        {intl.get('app_btn_export')}
      </Button>
    </div>
  );
};

export default Index;
